import { useResolveController, withNewContainer } from '@visiba/instantiation';
import type { ReactNode } from 'react';
import { IdentitySessionController } from './_identity_session.controller';

type IdentitySessionRootProps = {
	children: ReactNode;
};

export const IdentitySessionRoot = withNewContainer(function IdentitySessionRoot({ children }: IdentitySessionRootProps) {
	useResolveController(IdentitySessionController);

	return <>{children}</>;
});
